/**
 * Centralized code for change zip Fancybox on responsive theme.
 * @param {String} parentSelector A jQuery selector for the parent element triggering the change zip Fancybox.
 * @returns {undefined}
 */
const changeZipFancybox = function (parentSelector) {
	$(document).on('click', parentSelector + ' .updateZip', function(e) {
		e.preventDefault();
		$.fancybox({
			content: `
				<div class="p-3 bg-white">
					<form method="post">
						<div class="white-space-nowrap">
							<label class="h6 mb-3 d-block">Update delivery location</label>
							<input type="hidden" name="action" value="update_zip">
							<input type="text" class="text" name="zip" id="updateZip" placeholder="Enter 5-digit delivery zip" data-lpignore="true" data-1p-ignore>
							<input type="submit" class="btn btn-primary btn-lg update-zip-btn button" value="Go">
						</div>
					</form>
				</div>
			`,
			autoCenter: true,
			helpers: {
				overlay: {
					locked: true
				}
			},
			wrapCSS: 'customFancyBox changeZipContent'
		});
	});
};

export default changeZipFancybox;
